import styled from 'styled-components';

import {
  ColumnBlock,
  ColumnContent,
  ContentSection,
} from '../../../layout/components';

export const SplitSectionLeft = styled(ContentSection)`
  justify-content: flex-start;
`;

export const SplitSectionRight = styled(ContentSection)`
  justify-content: flex-end;
`;

export const BleedSectionLeft = styled(ContentSection)`
  justify-content: flex-start;
`;

export const BleedSectionRight = styled(ContentSection)`
  justify-content: flex-end;
`;

export const FigureBlock = styled(ColumnBlock).attrs({
  columns: 4,
})`
  //position: relative;
`;

export const FigureContainer = styled.div`
  width: 100%;
`;

export const SplitFigureBlock = styled(ColumnBlock).attrs({
  columns: 2,
})`
  position: relative;
`;

const MainFigureContainer = styled.div`
  width: 100%;
  padding-top: 39.7311827956989%;
  position: relative;
  z-index: 0;
  ${props =>
    props.breakpoint === 'phone' &&
    `
    padding-right: 2.5rem;
    padding-left: 2.5rem;
    padding-top: 46.984126984127%;
    left: -2.5rem;
    margin-bottom: 2.25rem;
    `};
`;

export const SplitFigureContainer = styled.div`
  width: 100%;
  padding-top: 100%;
  position: relative;
  ${props =>
    props.breakpoint === 'phone' &&
    `
    margin-bottom: 2.25rem;
  `};
`;

export const MainFigureContainerLeft = MainFigureContainer.extend`
  ${props =>
    props.breakpoint !== 'phone' &&
    `
  left: -1.875rem;
  padding-left: 1.875rem;
  padding-right: 1.875rem;
  `};
`;

export const MainFigureContainerRight = MainFigureContainer.extend`
  ${props =>
    props.breakpoint !== 'phone' &&
    `
    left: -1.875rem;
    padding-left: 1.875rem;
    padding-right: 1.875rem;
  `};
`;

export const SplitFigureContainerLeft = SplitFigureContainer.extend`
  left: -1.875rem;
  padding-right: 1.875rem;
  margin-bottom: 10rem;
`;

export const SplitFigureContainerRight = SplitFigureContainer.extend`
  right: -1.875rem;
  padding-left: 1.875rem;
  float: right;
  margin-bottom: 10rem;
`;

export const MainFigure = styled.figure`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const SquareMainFigure = MainFigure.extend`
  padding-bottom: 1.875rem;
`;

export const SquareSupportFigure = styled.figure`
  z-index: 1;
  ${props =>
    props.breakpoint !== 'phone'
      ? `
    width: 70.8333333333333%;
    height: 73.1182795698925%;
    top: 14.58333333333335%;
    left: 14.58333333333335%;
    `
      : `
    width: 100%;
    height: 100%;
    top: 0%;
    left: 0%;
  `} position: absolute;

  > div {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const SupportFigure = styled.figure`
  z-index: 2;
  position: absolute;
  width: ${props => (props.breakpoint === 'desktop' ? 42.5 : 31.7900390625)}%;
  padding-top: ${props =>
    props.breakpoint === 'desktop' ? 31.875 : 23.841796875}%;

  top: 69.3504736129905%;

  > div {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const SupportFigureLeft = SupportFigure.extend`
  left: ${props =>
    props.breakpoint === 'desktop' ? 12.890625 : 12.85556640625}%;
`;

export const SupportFigureRight = SupportFigure.extend`
  right: ${props =>
    props.breakpoint === 'desktop' ? 12.890625 : 12.85556640625}%;
`;

export const SquareSupportFigureLeft = SupportFigure.extend`
  width: 87.3529411764706%;
  padding-top: 62.0588235294118%;
  left: -39.7058823529412%;
  top: 73.5294117647059%;
`;

export const SquareSupportFigureRight = SupportFigure.extend`
  width: 87.3529411764706%;
  padding-top: 62.0588235294118%;
  right: -39.7058823529412%;
  top: 73.5294117647059%;
`;

const SupportFigurePortrait = SupportFigure.extend`
  width: 24.21875%;
  padding-top: 32.2916666666667%;
  top: 63.8998682476943%;
`;

export const SupportFigurePortraitLeft = SupportFigurePortrait.extend`
  left: 12.109375%;
`;

export const SupportFigurePortraitRight = SupportFigurePortrait.extend`
  right: 12.109375%;
`;

const HeaderBlock = styled(ColumnBlock).attrs({
  columns: 2,
})`
  ${props =>
    props.breakpoint !== 'phone' &&
    `
  position: absolute;
  z-index: 1;
  `};
`;

export const HeaderBlockRight = HeaderBlock.extend`
  ${props =>
    props.breakpoint !== 'phone' &&
    `
      right: 0;
    `};
`;

export const HeaderBlockLeft = HeaderBlock.extend`
  ${props =>
    props.breakpoint !== 'phone' &&
    `
    left: 0;
  `};
`;

export const HeaderContentLeft = styled(ColumnContent).attrs({
  paddingLeft: props =>
    props.breakpoint === 'desktop' ? '12.0rem' : '5.625rem',
  paddingRight: '3.75rem',
  //paddingRight: '10.5rem',
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '7.5rem'),
})``;

export const HeaderContentRight = styled(ColumnContent).attrs({
  paddingLeft: props =>
    props.breakpoint === 'desktop' ? '14.5rem' : '3.75rem',
  paddingRight: '3.75rem',
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '7.5rem'),
})``;

export const SplitHeaderContentLeft = styled(ColumnContent).attrs({
  paddingTop: '0',
  paddingRight: props => (props.breakpoint === 'tablet' ? '8.75rem' : '12rem'),
  paddingLeft: '10.5rem',
})``;

export const SplitHeaderContentRight = styled(ColumnContent).attrs({
  paddingTop: '0',
  paddingLeft: props => (props.breakpoint === 'tablet' ? '8.75rem' : '12rem'),
  paddingRight: '10.5rem',
})``;

export const TextBlock = styled(ColumnBlock).attrs({
  columns: 2,
})`
  h2 {
    font-size: ${props => (props.breakpoint !== 'phone' ? 4.5 : 3.5)}rem;
  }
`;

export const TextBlockPortraitLeft = styled(TextBlock).attrs({
  columns: props => (props.breakpoint === 'tablet' ? 2.5 : 2),
})`
  left: ${props =>
    props.breakpoint === 'phone'
      ? 0
      : props.breakpoint === 'tablet' ? '12.5%' : 'unset'};
`;

export const TextBlockPortraitRight = styled(TextBlock).attrs({
  columns: props => (props.breakpoint === 'tablet' ? 2.5 : 2),
})`
  right: ${props =>
    props.breakpoint === 'phone'
      ? 0
      : props.breakpoint === 'tablet' ? '12.5%' : 'unset'};
`;

export const TextContentLeft = styled(ColumnContent).attrs({
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '4.5rem'),
  paddingLeft: '5.625rem',
  paddingRight: props =>
    props.breakpoint === 'desktop' ? '18.75rem' : '3.75rem',
})`
  min-height: ${props => (props.breakpoint !== 'phone' ? '25rem' : 'unset')};
`;

export const TextContentRight = styled(ColumnContent).attrs({
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '4.5rem'),
  paddingLeft: props =>
    props.breakpoint === 'desktop' ? '13.755rem' : '3.75rem',
  paddingRight: props =>
    props.breakpoint === 'desktop' ? '10.625rem' : '5.625rem',
})`
  min-height: ${props => (props.breakpoint !== 'phone' ? '25rem' : 'unset')};
`;

export const TextContentPortraitLeft = styled(ColumnContent).attrs({
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '4.5rem'),
  paddingLeft: '7.5rem',
  paddingRight: '5.625rem',
})`
  min-height: ${props => (props.breakpoint !== 'phone' ? '25rem' : 'unset')};
`;

export const TextContentPortraitRight = styled(ColumnContent).attrs({
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '4.5rem'),
  paddingLeft: '5.625rem',
  paddingRight: '7.5rem',
})`
  min-height: ${props => (props.breakpoint !== 'phone' ? '25rem' : 'unset')};
`;



// WEBPACK FOOTER //
// ./src/modules/pages/components/sections/ui.js